import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=58f4bf91"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=58f4bf91&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f4bf91')) {
      api.createRecord('58f4bf91', component.options)
    } else {
      api.reload('58f4bf91', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=58f4bf91", function () {
      api.rerender('58f4bf91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Modal/Modal.vue"
export default component.exports